const Loading = () => {
  return (
    <div className="w-[100dvw] h-[100dvh] flex justify-center items-center">
      <div className="w-10 h-10 border-4 border-gray-300 round-[50%] animate-spin duration-1000 ease-linear infinite"></div>
    </div>
  );
};

export default Loading;
